/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDisableUserOptions, AdminDisableUserResponses } from '../../models/AdminDisableUser'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Disable User
 * {@link /admin/users/:user_id/disable}
 */
export function adminDisableUser<ThrowOnError extends boolean = true>(options: Options<AdminDisableUserOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDisableUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/users/{user_id}/disable', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDisableUserResponses, ThrowOnError>>
}
